// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class HeaderBadge extends WebComponent {
  constructor(props) {
    super(props);
  }
  didMount() {
    const header = this.element;
    const headerWidth = header.offsetWidth;
    const badgeEl = document.createElement('span');
    badgeEl.classList.add('header-badge');
    badgeEl.style.width = headerWidth + 'px';
    badgeEl.style.height = headerWidth + 'px';
    header.appendChild(badgeEl);
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/HeaderBadge.js